export default __webpack_public_path__ + "static/centralized-platform-light-0aae4e0df8ca33d9fcd78491af0c0876.svg";